export const URLEndpoints = {
  ExamMaster: {
    ExamRegistrationLogin: 'ExamMaster/ExamRegistrationLogin',
    ReadExaminationForExternalApply: 'ExamMaster/ReadExaminationForExternalApply',
    ReadPaperDetailsForExternalExamApply: 'ExamMaster/ReadPaperDetailsForExternalExamApply',
    UpdateExternalExamRegistration: 'ExamMaster/UpdateExternalExamRegistration',
    ReadStudentCondonationAllSemDetails: 'ExamMaster/ReadStudentCondonationAllSemDetails',
    ReadStudentEnrollmentDetails: 'ExamMaster/ReadStudentEnrollmentDetails',
    ReadStudentAddressDetails: 'ExamMaster/ReadStudentAddressDetails',
    UpdateStudentAddress: 'ExamMaster/UpdateStudentAddress',
    ReadStudentCountForBundling:'ExamMaster/ReadStudentCountForBundling',
    ReadQPforBundling:'ExamMaster/ReadQPforBundling',
    IssueQPBundling:'ExamMaster/IssueQPBundling',
    ReturnQPBundling:'ExamMaster/ReturnQPBundling',
    ReadBundlingDetails:'ExamMaster/ReadBundlingDetails',
    ReadCurrentController:'ExamMaster/ReadCurrentController',
    ReadPaperForValuationDutyAssign:'ExamMaster/ReadPaperForValuationDutyAssign',
    ReadChairmanPanel:'ExamMaster/ReadChairmanPanel',
    GetStudentsForValuationBundling:'ExamMaster/GetStudentsForValuationBundling',
    UpdateChairmanPanel:'ExamMaster/UpdateChairmanPanel',
    AllotStudentForValuation:'ExamMaster/AllotStudentForValuation',
    ReadChiefPanel:'ExamMaster/ReadChiefPanel'

  },

  PrincipalDashboard: {
    ReadStaffCountDepartmentWise: 'PrincipalDashboard/ReadStaffCountDepartmentWise',
    ReadTimetableToday:'PrincipalDashboard/ReadTimetableToday',
    ReadGeneralDetailsCount:'PrincipalDashboard/ReadGeneralDetailsCount',
    ReadUnmarkedHourCount:'PrincipalDashboard/ReadUnmarkedHourCount',
    ReadUnMarkedStaffHourDetails:'PrincipalDashboard/ReadUnMarkedStaffHourDetails',
    ReadAttendanceShortageList:'PrincipalDashboard/ReadAttendanceShortageList',
    ReadPOEnterAndNonEnteredDetails:'PrincipalDashboard/ReadPOEnterAndNonEnteredDetails',
    ReadCOEnteredCountDetails:'PrincipalDashboard/ReadCOEnteredCountDetails',
    ReadCOEnterAndNonEnteredDetails:'PrincipalDashboard/ReadCOEnterAndNonEnteredDetails',
    ReadStaffLeaveDetails:'PrincipalDashboard/ReadStaffLeaveDetails',
    ReadStaffLeaveCount:'PrincipalDashboard/ReadStaffLeaveCount',
    ReadStaffLeaveCountLeaveTypeWise:'PrincipalDashboard/ReadStaffLeaveCountLeaveTypeWise',
    ReadStaffWorkloadCount:'PrincipalDashboard/ReadStaffWorkloadCount',
    ReadStaffWorkloadDetails:'PrincipalDashboard/ReadStaffWorkloadDetails',
    ReadStaffDetails:'PrincipalDashboard/ReadStaffDetails',
    ReadUnmarkedWorkDiary:'PrincipalDashboard/ReadUnmarkedWorkDiary'
  }
};



export enum AIapiBaseURLs{
      CourseRecommendation=  "https://course-recommendation.meshilogic.com"
}

export enum AIUrlEndPoints{


}